import { defaultNotFoundImage } from '../helpers'

export const findIncluded = (includedArray, resourceType, resourceId) => {
  return includedArray.filter(
    resource => resource.type === resourceType && resource.id === resourceId
  )[0]
}

export const findIncludedItems = included => {
  return included.filter(resource => resource.type === 'orderItems')
}

export const deconstructRecipient = recipient => {
  if (!recipient) {
    return {}
  }

  return {
    recipientName: recipient.attributes.name,
    recipientCompany: recipient.attributes.company,
    recipientPhone: recipient.attributes.phone,
    recipientAddress: {
      addressOne: recipient.attributes.addressOne,
      addressTwo: recipient.attributes.addressTwo,
      city: recipient.attributes.city,
      state: recipient.attributes.state,
      zipcode: recipient.attributes.zipcode,
      country: recipient.attributes.country
    }
  }
}

export const deconstructSender = user => {
  return {
    id: user.id,
    email: user.attributes.email,
    name: user.attributes.fullName
  }
}

export const deconstructShipmentOption = shipmentOption => {
  return {
    id: shipmentOption.id,
    name: shipmentOption.attributes.name,
    cost: shipmentOption.attributes.cost,
    description: shipmentOption.attributes.description
  }
}

export const deconstructIntegration = integration => {
  return {
    id: integration.id,
    provider: integration.attributes.provider,
    updatedAt: integration.attributes.updatedAt,
    createdAt: integration.attributes.createdAt
  }
}

export const deconstructOrder = order => {
  return {
    id: order.id,
    orderId: order.attributes.orderId,
    canCancelOrder: order.attributes.canCancelOrder,
    status: order.attributes.state,
    subteam: order.attributes.subteam
      ? { id: order.attributes.subteam.id, name: order.attributes.subteam.name }
      : {},
    subtotal: order.attributes.subtotal,
    taxRate: order.attributes.taxRate,
    taxAmount: order.attributes.taxAmount,
    shippingFee: order.attributes.shippingFee,
    discount: order.attributes.discount,
    total: order.attributes.total,
    note: order.attributes.note,
    paigeGroupOrderId: order.attributes.paigeGroupOrderId
      ? order.attributes.paigeGroupOrderId
      : null,
    paigeGroupOrderName: order.attributes.paigeGroupOrderName,
    cardMessage: order.attributes.cardMessage,
    createdAt: order.attributes.createdAt,
    processingStartDate: order.attributes.processingStartDate,
    paymentSource: order.attributes.paymentSource,
    salesforceResourceType: order.attributes.salesforceResourceType,
    salesforceResourceUid: order.attributes.salesforceResourceUid,
    deliveryName: order.attributes.deliveryName,
    deliveryCompany: order.attributes.deliveryCompany,
    deliveryEmail: order.attributes.deliveryEmail,
    deliveryAddressOne: order.attributes.deliveryAddressOne,
    deliveryAddressTwo: order.attributes.deliveryAddressOne,
    deliveryCity: order.attributes.deliveryCity,
    deliveryState: order.attributes.deliveryState,
    deliveryZipcode: order.attributes.deliveryZipcode,
    deliveryCountry: order.attributes.deliveryCountry,
    deliveryPhone: order.attributes.deliveryPhone,
    trackingUrl: order.attributes.trackingUrl,
    trackingNumber: order.attributes.trackingNumber,
    carrierCode: order.attributes.carrierCode,
    serviceCode: order.attributes.serviceCode,
    teamId:
      order.relationships.team.data === null
        ? null
        : order.relationships.team.data.id,
    recipientId:
      order.relationships.recipient.data === null
        ? null
        : order.relationships.recipient.data.id,
    userId:
      order.relationships.user.data === null
        ? null
        : order.relationships.user.data.id
  }
}

// note: takes in a deconstructed order
// this is where TypeScript could have come in handy
export const deconstructOrderListForm = ({
  id,
  createdAt,
  senderName,
  senderEmail,
  recipientName,
  status,
  trackingUrl
}) => {
  return {
    id,
    createdAt,
    senderName,
    senderEmail,
    recipientName,
    status,
    trackingUrl,
    detailsUrl: `${window.location.origin}/orders/${id}`
  }
}

export const deconstructItem = item => {
  return {
    id: item.id,
    name: item.attributes.name,
    displayName: item.attributes.displayName,
    sku: item.attributes.sku,
    description: item.attributes.description,
    price: item.attributes.price,
    quantity: item.attributes.quantity,
    amount: item.attributes.amount,
    productVariantId:
      item.relationships.productVariant.data === null
        ? null
        : item.relationships.productVariant.data.id,
    size: item.attributes.size ? item.attributes.size.name : '',
    color: item.attributes.color ? item.attributes.color.name : '',
    type: item.attributes.variantType ? item.attributes.variantType.name : '',
    variantImage:
      item.attributes.representativeImages !== null
        ? item.attributes.representativeImages.length
          ? item.attributes.representativeImages[0].url
          : defaultNotFoundImage
        : defaultNotFoundImage,
    productName: item.attributes.productName
  }
}

export const deconstructOrderDetail = order => {
  return {
    ...deconstructOrder(order)
    // items: order.items.data.map(deconstructItem)
  }
}

export const deconstructSubscriptionData = subscriptionData => {
  return {
    id: parseInt(subscriptionData.id, 10),
    planID: subscriptionData.attributes.planId,
    quantity: subscriptionData.attributes.quantity,
    status: subscriptionData.attributes.status,
    trialStartAt: subscriptionData.attributes.trialStartAt,
    trialEndAt: subscriptionData.attributes.trialEndAt,
    currentPeriodStartAt: subscriptionData.attributes.currentPeriodStartAt,
    currentPeriodEndAt: subscriptionData.attributes.currentPeriodEndAt,
    cancelAt: subscriptionData.attributes.cancelAt,
    canceledAt: subscriptionData.attributes.canceledAt,
    endedAt: subscriptionData.attributes.endedAt,
    cancelAtPeriodEnd: subscriptionData.attributes.cancelAtPeriodEnd
  }
}
